import React from "react";

// Entegrasyon kart durumu → rozet stili.
// connected: Aktif · passive: Pasif · pending: Süreç Devam Ediyor · soon: Çok Yakında
const STATUS_MAP = {
    connected: { label: "Aktif", color: "#2f9e44", bg: "rgba(47,158,68,.12)" },
    passive: { label: "Pasif", color: "#5c6a86", bg: "rgba(92,106,134,.12)" },
    pending: { label: "Süreç Devam Ediyor", color: "#E8590C", bg: "rgba(232,89,12,.12)" },
    soon: { label: "Çok Yakında", color: "#b0870b", bg: "rgba(229,106,34,.18)" },
};

export default function IntegrationStatusBadge({ status }) {
    const s = STATUS_MAP[status] || STATUS_MAP.passive;
    return (
        <span
            className="d-inline-flex align-items-center fw-semibold"
            style={{
                color: s.color,
                backgroundColor: s.bg,
                borderRadius: 999,
                padding: ".25rem .7rem",
                fontSize: 12,
                lineHeight: 1.4,
            }}
        >
            {s.label}
        </span>
    );
}
